const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  // ttIncome=123
  searchSuspected ({ state, commit, rootState }, params) {
    return rootState.axios.get('/wallet/txntw/v1frontend/txntw/search-suspected', {
      params,
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
  }
}
